<div class="spinner-container">
  <svg
    [class]="effect ? effect + '-spinner' : ''"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="puzzle-blue"
      d="M33.2385 0H8.3775C4.68488 0 1.69141 2.93441 1.69141 6.55418V30.9246C1.69141 34.5444 4.68488 37.4788 8.3775 37.4788H33.2385C36.9311 37.4788 39.9245 34.5444 39.9245 30.9246V6.55418C39.9245 2.93441 36.9311 0 33.2385 0Z"
      fill="#405EFE"
    />
    <path
      class="puzzle-yellow"
      d="M19.9641 14.678H6.6861C2.99347 14.678 0 17.6124 0 21.2322V40.7101C0 44.3298 2.99347 47.2642 6.6861 47.2642H19.9641C23.6567 47.2642 26.6502 44.3298 26.6502 40.7101V21.2322C26.6502 17.6124 23.6567 14.678 19.9641 14.678Z"
      fill="#F2CC0F"
    />
    <path
      class="puzzle-red"
      d="M38.2318 27.6931H18.3618C14.6692 27.6931 11.6758 30.6275 11.6758 34.2473V44.217C11.6758 47.8368 14.6692 50.7712 18.3618 50.7712H38.2318C41.9244 50.7712 44.9179 47.8368 44.9179 44.217V34.2473C44.9179 30.6275 41.9244 27.6931 38.2318 27.6931Z"
      fill="#F00444"
    />
    <path
      class="puzzle-orange"
      d="M43.3137 0H30.0357C26.3431 0 23.3496 2.93441 23.3496 6.55418V37.4788C23.3496 41.0986 26.3431 44.033 30.0357 44.033H43.3137C47.0063 44.033 49.9998 41.0986 49.9998 37.4788V6.55418C49.9998 2.93441 47.0063 0 43.3137 0Z"
      fill="#D96704"
    />
  </svg>
</div>
